import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListFirstNameCell } from './user-list-first-name.cell';
import { UserListFirstNameHeader } from './user-list-first-name.header';

export const UserListFirstNameColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['firstName']
> = {
  enableSorting: true,
  header: UserListFirstNameHeader,
  cell: UserListFirstNameCell,
};
